import { PropTypeMediaEntry } from "fleet/prop-types";
import { getArchiveStatus, isVideo } from "fleet/view/media-library/utils";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { AppUnavailable } from "ui/app-unavailable/app-unavailable";
import { ContentArchived } from "ui/content-archived";
import { Table, Column } from "ui/table";
import { formatSpotPreview, formatTags } from "util/table-format";
import { durationToHuman } from "util/time";

import { PropTypePriorities } from "./utils";

class SpotTable extends React.PureComponent {
  static get propTypes() {
    return {
      changePriorityOrder: PropTypes.func,
      deleteSpot: PropTypes.func,
      hideSidebar: PropTypes.func,
      priority: PropTypePriorities.isRequired,
      showSidebar: PropTypes.func,
      spots: PropTypes.arrayOf(PropTypeMediaEntry),
    };
  }

  static get defaultProps() {
    return {
      changePriorityOrder: () => {},
      deleteSpot: () => {},
      hideSidebar: () => {},
      showSidebar: () => {},
    };
  }

  constructor(props) {
    super(props);

    const LabelTag = <Badge variant="danger" />;

    this._formatActions = this._formatActions.bind(this);
    this._formatCategory = formatTags.bind(null, LabelTag);

    this.selectRow = {
      clickToSelect: true,
      hideSelectColumn: true,
      mode: "radio",
      onSelect: this._onRowClick.bind(this),
    };
  }

  _formatActions(_cell, _row, rowIndex) {
    const { spots } = this.props;
    const numSpots = spots.length;

    return (
      <div className="content-table-actions button-spacing">
        <Button
          className="change-order"
          disabled={rowIndex === 0}
          onClick={(e) => this._changeOrder(-1, rowIndex, e)}
          title="Move up"
          variant="secondary"
        >
          <i className="fa fa-caret-up" aria-hidden="true" />
        </Button>
        <Button
          className="change-order"
          disabled={rowIndex === numSpots - 1}
          onClick={(e) => this._changeOrder(1, rowIndex, e)}
          title="Move down"
          variant="secondary"
        >
          <i className="fa fa-caret-down" aria-hidden="true" />
        </Button>
        <Button
          className="delete-content"
          title="Delete this entry"
          onClick={(e) => this._deleteEntry(rowIndex, e)}
          variant="secondary"
        >
          <i className="fa fa-trash" aria-hidden="true" />
        </Button>
      </div>
    );
  }

  _changeOrder(dir, index, e) {
    e.preventDefault();
    e.stopPropagation();

    const { changePriorityOrder, priority } = this.props;
    
    const payload = {
      dir,
      index,
      priority,
    };

    changePriorityOrder(payload);
  }

  _deleteEntry(index, e) {
    e.preventDefault();
    e.stopPropagation();

    const { deleteSpot, priority } = this.props;
    const payload = {
      index,
      priority,
    };

    deleteSpot(payload);
  }

  _formatDuration(duration, mediaEntry) {
    if (isVideo(mediaEntry.mimeType)) {
      return "N/A";
    }

    return durationToHuman(duration);
  }

  _formatName(name, mediaEntry) {
    if (mediaEntry.type === "application" && !mediaEntry.available) {
      name = "";
    }

    return (
      <div>
        {name}
        <AppUnavailable mediaEntry={mediaEntry} />
        <ContentArchived mediaEntry={mediaEntry} />
      </div>
    );
  }

  _onRowClick(row) {
    const { priority, showSidebar } = this.props;

    showSidebar(priority, row._rowNum);
  }

  _rowClass(row) {
    const archiveStatus = getArchiveStatus(row);
    const archivedClass = archiveStatus ? "spot-list-archived-content" : "";

    return `clickable ${archivedClass}`;
  }

  _renderTable(tableData) {
    return (
      <Table
        data={tableData}
        hover={true}
        rowClasses={this._rowClass}
        selectRow={this.selectRow}
      >
        <Column
          key="_rowNum"
          dataField="_rowNum"
          isKey={true}
          dataFormat={(val) => val + 1}
          width="60px"
          dataAlign="center"
        >
          Order
        </Column>
        <Column
          dataField="url"
          dataFormat={formatSpotPreview}
          width="100px"
          dataAlign="center"
        >
          Preview
        </Column>
        <Column dataField="name" dataFormat={this._formatName}>
          Name
        </Column>
        <Column
          dataField="duration"
          dataFormat={this._formatDuration}
          width="100px"
        >
          Duration
        </Column>
        <Column dataField="friendlyType" width="150px">
          Type
        </Column>
        <Column dataField="tag" dataFormat={this._formatCategory}>
          Creative Category
        </Column>
        <Column dataField="actions" dataFormat={this._formatActions}>
          Actions
        </Column>
      </Table>
    );
  }

  render() {
    const { spots } = this.props;

    return (
      <div className="strategy-content-table">{this._renderTable(spots)}</div>
    );
  }
}

export { SpotTable };
